import type { MetricRate } from '@/types/sentinelAnalytics';
import { cn } from '@/lib/utils';
import { formatFraction, formatPercent } from './format';

interface RateCellProps {
  metric: MetricRate;
  /** Space between the rate and its fraction; Figma uses 10px in Ticket Metrics and 16px in Message Metrics. */
  gap?: 'tight' | 'wide';
}

export function RateCell({ metric, gap = 'wide' }: RateCellProps) {
  return (
    <span className={cn('flex items-baseline tabular-nums', gap === 'wide' ? 'gap-4' : 'gap-2.5')}>
      {formatPercent(metric.rate)}<span className='text-[11px] leading-4 text-gray-900'>({formatFraction(metric)})</span>
    </span>
  );
}
